/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Ptz_UpInputs */

const vi_grower_area_camera_ptz_up = /** @type {(inputs: Grower_Area_Camera_Ptz_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quay lên`)
};

/**

* @param {Grower_Area_Camera_Ptz_UpInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_ptz_up = /** @type {((inputs?: Grower_Area_Camera_Ptz_UpInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Ptz_UpInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_ptz_up(inputs)
});